import { render, staticRenderFns } from "./ConfigPerfis.vue?vue&type=template&id=b7c1ce46&scoped=true&lang=pug&"
import script from "./ConfigPerfis.vue?vue&type=script&lang=js&"
export * from "./ConfigPerfis.vue?vue&type=script&lang=js&"
import style0 from "./ConfigPerfis.vue?vue&type=style&index=0&id=b7c1ce46&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c1ce46",
  null
  
)

export default component.exports